export default __webpack_public_path__ + "static/media/ux-interface.be5b11c1.webp";